import React from 'react';

import PortfolioGalleryCommon from '../../layouts-components__common-cases/portfolio-gallery';

import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const PortfolioGalleryArr = [
    '/images/pic/tech-leaders/tech-leaders__portfolio-gallery-item-img1.png',
    '/images/pic/tech-leaders/tech-leaders__portfolio-gallery-item-img2.png',
    '/images/pic/tech-leaders/tech-leaders__portfolio-gallery-item-img3.png',
    '/images/pic/tech-leaders/tech-leaders__portfolio-gallery-item-img4.png',
    '/images/pic/tech-leaders/tech-leaders__portfolio-gallery-item-img5.png',
    '/images/pic/tech-leaders/tech-leaders__portfolio-gallery-item-img6.png',
    '/images/pic/tech-leaders/tech-leaders__portfolio-gallery-item-img7.png',
    '/images/pic/tech-leaders/tech-leaders__portfolio-gallery-item-img8.png',
    '/images/pic/tech-leaders/tech-leaders__portfolio-gallery-item-img9.png',
    '/images/pic/tech-leaders/tech-leaders__portfolio-gallery-item-img10.png',
    '/images/pic/tech-leaders/tech-leaders__portfolio-gallery-item-img11.png',
    '/images/pic/tech-leaders/tech-leaders__portfolio-gallery-item-img12.png',
    '/images/pic/tech-leaders/tech-leaders__portfolio-gallery-item-img13.png',
    '/images/pic/tech-leaders/tech-leaders__portfolio-gallery-item-img14.png',
    '/images/pic/tech-leaders/tech-leaders__portfolio-gallery-item-img15.png',
    '/images/pic/tech-leaders/tech-leaders__portfolio-gallery-item-img16.png',
    '/images/pic/tech-leaders/tech-leaders__portfolio-gallery-item-img17.png',
    '/images/pic/tech-leaders/tech-leaders__portfolio-gallery-item-img18.png',
    '/images/pic/tech-leaders/tech-leaders__portfolio-gallery-item-img19.png',
];

const PortfolioGallery = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <PortfolioGalleryCommon
                imgList={PortfolioGalleryArr}
                smallPaddings={true}
                isMargin={false}
            />
        </ScrollAnimation>
    );
};

export default PortfolioGallery;
